import { ImageFill as sImageFill } from "@evergis/sgis/es/symbols/polygon/ImageFill";
import { PolygonSymbol, PatternBrush, isDashedBrush } from "../../interfaces/style";
import { getParameterValue } from "../../evergis/core/classification/getFromClassified";
import { getLineDash } from "./SymbolRenderer/strokeStyle";
import { getHexColor } from "../../utils/color";

export class SGisImageFill extends sImageFill {
  constructor(public originalSymbol: PolygonSymbol<PatternBrush>) {
    super({
      strokeColor: getHexColor(getParameterValue(originalSymbol.stroke?.color)),
      strokeWidth: getParameterValue(originalSymbol.stroke?.width),
      lineDash: getLineDash(originalSymbol.stroke),
      src: `data:image/png;base64,${originalSymbol.fill.pattern}`,
      lineCap: isDashedBrush(originalSymbol.stroke) ? "square" : "round",
    });
  }

  clone() {
    return new SGisImageFill(this.originalSymbol);
  }
}
